import React, { Component } from 'react';
import CreateUserForm from '../../../../../../../../components/CreateUserForm';

/**
 * Create User screen, for creating a user.
 *
 * @extends React.Component
 */
class CreateUser extends Component {
  render() {
    return (
      <CreateUserForm />
    );
  }
}

export default CreateUser;



// WEBPACK FOOTER //
// ./src/screens/AdvisoryApp/screens/Settings/screens/Users/screens/CreateUser/index.js